import { QuestionnaireManager } from "@/components/admin/QuestionnaireManager";

// Questionnaires section: the full questionnaire authoring UI is embedded
// directly here. Gated by write:any:questionnaire in SettingsPage.
export function FragebogenPanel() {
  return <QuestionnaireManager />;
}
